module.exports = __webpack_public_path__ + "img/lianxi.93c36423.jpg";